import { Component } from '@angular/core';

@Component({
    selector: 'fi-profile-view-data-list-content',
    template: '<ng-content></ng-content>',
    standalone: false,
})
export class FiProfileViewTranscludeComponent {}
